export const Background = {
  notFound: '//st.bork.ru/app-bork-ru/background-404.jpg'
};
